import React from 'react'
import {
  IconInfoDefault,
  Tooltip as DSTooltip,
  TooltipContent,
  TooltipToggle,
} from '@mc/design-system'

export interface TooltipProps {
  iconSrText: string
  contentText: string
  onClick: () => void
}

export const Tooltip = ({ iconSrText, contentText, onClick }: TooltipProps) => (
  <DSTooltip placement='top-end'>
    <TooltipToggle>
      <button className='mc-ml-1' style={{ lineHeight: '0' }} onClick={onClick}>
        <IconInfoDefault size={2} srText={iconSrText} />
      </button>
    </TooltipToggle>

    <TooltipContent>{contentText}</TooltipContent>
  </DSTooltip>
)
